export default __webpack_public_path__ + "static/media/Ballroll_00241.07ea1041.png";